import React from 'react';

// Columns of stacked segments over a shared peak - one widget for both the
// opens-by-hour histogram and the sends-per-day chart.
export default function BucketChart({ buckets, emptyLabel, labelEvery = 1 }) {
  const peak = Math.max(...buckets.map((b) => b.segments.reduce((sum, s) => sum + s.value, 0)), 0);
  if (peak === 0) return <div className="unibox-empty">{emptyLabel}</div>;

  return (
    <div className="bucket-chart-bars">
      {buckets.map((bucket, index) => (
        <div key={bucket.key} className="bucket-chart-column" title={bucket.title}>
          <div className="bucket-chart-stack">
            {bucket.segments
              .filter((segment) => segment.value > 0)
              .map((segment) => (
                <div
                  key={segment.key}
                  className="bucket-chart-segment"
                  style={{ height: `${(segment.value / peak) * 100}%`, background: segment.color }}
                />
              ))}
          </div>
          <span className="bucket-chart-label">
            {index % labelEvery === 0 ? bucket.label : ''}
          </span>
        </div>
      ))}
    </div>
  );
}
